import React, { useMemo } from 'react';
import { useTheme } from '../../hooks/theme';
import { Paragraph } from '../Typography';
import { Container } from './Status.styles';

import { StatusProps } from './Status.types';

export function Status({ size, variant, label, ...props }: StatusProps) {
  const theme = useTheme();

  const color = useMemo(() => {
    if (variant === 'warning') {
      return theme.colors.support.graneleiro[100];
    }
    if (variant === 'success') {
      return theme.colors.brand.primary[100];
    }
    if (variant === 'error') {
      return theme.colors.support.vanderleia[100];
    }
    if (variant === 'info') {
      return theme.colors.support.hopper[100];
    }
    if (variant === 'support') {
      return theme.colors.support.bau[100];
    }
    if (variant === 'support2') {
      return theme.colors.support.gaiola[100];
    }
    if (variant === 'support3') {
      return theme.colors.support.dolly[100];
    }
    if (variant === 'support4') {
      return theme.colors.brand.secondary[60];
    }
    if (variant === 'inactive') {
      return theme.colors.neutral.grey[40];
    }
    return theme.colors.neutral.grey[40];
  }, [theme.colors, variant]);

  return (
    <Container {...props}>
      <svg
        width={size ?? 12}
        height={size ?? 12}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Status {variant}</title>
        <circle opacity="0.6" cx="6" cy="6" r="6" fill={color ?? 'currentColor'} />
        <circle cx="6" cy="6" r="4" fill={color ?? 'currentColor'} />
      </svg>
      <div style={{ width: '4px' }} />
      <Paragraph variant="p2">{label}</Paragraph>
    </Container>
  );
}
